// Per-route SEO metadata for The Kitchen Art Co.
export const SITE_URL = "https://www.tkac.in";

export const SEO_MAP = {
  "/": {
    title: "The Kitchen Art Co. — Luxury Catering & Hospitality House Since 1997",
    desc: "The Kitchen Art Co. is one of India's leading luxury catering companies — bespoke weddings, cultural celebrations and intimate gatherings, crafted with quiet luxury since 1997.",
  },
  "/legacy": {
    title: "The Legacy — Three Decades of Luxury Catering | The Kitchen Art Co.",
    desc: "The saga, milestones and celebrated events of The Kitchen Art Co. — a luxury catering house serving India and the world since 1997.",
  },
  "/our-people": {
    title: "Our People — The Team Behind The Kitchen Art Co.",
    desc: "Meet the chefs, hosts and craftspeople behind The Kitchen Art Co., devoted to high-end catering and hospitality.",
  },
  "/culinary": {
    title: "The Art — Menus & Culinary Craft | The Kitchen Art Co.",
    desc: "Explore the culinary craft of The Kitchen Art Co. — vegetarian and non-vegetarian menus, sit-down service, live-fire stations and bespoke tasting.",
  },
  "/experiences": {
    title: "Experiences — Weddings, Cultural Occasions & Intimate Gatherings",
    desc: "Luxury catering experiences by The Kitchen Art Co. — weddings, cultural occasions and intimate gatherings, designed and executed end to end.",
  },
  "/journal": {
    title: "The Journal — Places, Journeys & Culinary Notes | The Kitchen Art Co.",
    desc: "Notes from the house: places, journeys and culinary stories from The Kitchen Art Co.",
  },
  "/press-kit": {
    title: "Press & Accolades — The Kitchen Art Co.",
    desc: "Press coverage, accolades and media resources for The Kitchen Art Co., a luxury catering house since 1997.",
  },
  "/contact": {
    title: "Contact — Begin a Conversation | The Kitchen Art Co.",
    desc: "Enquire with The Kitchen Art Co. for luxury catering in Delhi and across India. Begin a conversation about your event.",
  },
  "/legal": {
    title: "Legal & Privacy — The Kitchen Art Co.",
    desc: "Legal information and privacy policy for The Kitchen Art Co.",
  },
};

// Old (pre-2026) URLs -> new page, so Google carries rankings across.
export const REDIRECTS = {
  "/index.php": "/",
  "/index.html": "/",
  "/aboutus.php": "/legacy",
  "/the-saga.php": "/legacy",
  "/the-team.php": "/our-people",
  "/puneet-sikand.php": "/our-people",
  "/jayotika-sikand.php": "/our-people",
  "/dinyar-banker.php": "/our-people",
  "/sharad-dahiya.php": "/our-people",
  "/ramit-wason.php": "/our-people",
  "/manish-thakur.php": "/our-people",
  "/jitendra-jha.php": "/our-people",
  "/sanju-kumar.php": "/our-people",
  "/rajiv-thaparis.php": "/our-people",
  "/art-in-the-kitchen.php": "/culinary",
  "/menus.php": "/culinary",
  "/veg-menu/breakfast-and-lunches.php": "/culinary",
  "/veg-menu/cocktails-and-dinners.php": "/culinary",
  "/veg-menu/celebrations-and-themes.php": "/culinary",
  "/veg-menu/barbecue-and-grill.php": "/culinary",
  "/veg-menu/corporate-and-embassy.php": "/culinary",
  "/veg-menu/religious-ceremonies.php": "/culinary",
  "/veg-menu/sit-down-service.php": "/culinary",
  "/veg-menu/wedding.php": "/culinary",
  "/nonveg-menu/breakfast-and-lunches.php": "/culinary",
  "/nonveg-menu/cocktails-and-dinners.php": "/culinary",
  "/nonveg-menu/celebrations-and-themes.php": "/culinary",
  "/nonveg-menu/barbecue-and-grill.php": "/culinary",
  "/nonveg-menu/corporate-and-embassy.php": "/culinary",
  "/nonveg-menu/sit-down-service.php": "/culinary",
  "/nonveg-menu/wedding.php": "/culinary",
  "/clients.php": "/legacy",
  "/bookings.php": "/legacy",
  "/accolades-press.php": "/press-kit",
  "/blog": "/journal",
  "/blog/": "/journal",
  "/careers.php": "/contact",
  "/contactus.php": "/contact",
  "/legal.php": "/legal",
  "/site-map.php": "/",
};
